import { render, staticRenderFns } from "./CreateNewAccount.vue?vue&type=template&id=a6925752&scoped=true"
import script from "./CreateNewAccount.vue?vue&type=script&lang=js"
export * from "./CreateNewAccount.vue?vue&type=script&lang=js"
import style0 from "./CreateNewAccount.vue?vue&type=style&index=0&id=a6925752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6925752",
  null
  
)

export default component.exports